<template>
  <el-button-group>
    <el-button
      @click="$emit('input', NOTES_READING_MODE.LONG)"
      :class="{
        'u-background--info-light': value === NOTES_READING_MODE.LONG,
        'u-text--link': value === NOTES_READING_MODE.LONG
      }"
      class="u-p2"
      data-element="long-reading-mode-button"
    >
      <fa-icon
        icon="bc-two-bars" />
    </el-button>
    <el-button
      @click="$emit('input', NOTES_READING_MODE.SHORT)"
      :class="{
        'u-background--info-light': value === NOTES_READING_MODE.SHORT,
        'u-text--link': value === NOTES_READING_MODE.SHORT
      }"
      class="u-p2"
      data-element="short-reading-mode-button"
    >
      <fa-icon
        icon="bc-three-bars" />
    </el-button>
  </el-button-group>
</template>

<script>
import {NOTES_READING_MODE} from './definitions'
export default {
  name: 'NotesReadingModeToggle',
  props: {
    value: {
      type: String,
      default: 'short',
      validator: (v) => Object.values(NOTES_READING_MODE).includes(v)
    }
  },
  data () {
    return {
      NOTES_READING_MODE
    }
  }
}
</script>
